module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedBold.41ef5c9.ttf";